import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type Bbfc18Props = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const Bbfc18 = ({ height = 35, sx, width = 35 }: Bbfc18Props) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 92.604" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M444.047 273.898h55.984v55.985h-55.984zm0 0" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" transform="matrix(1.6541 0 0 1.6541 -734.501 -453.057)">
      <path
        d="M472.04 328.898c-14.919 0-27.009-12.093-27.009-27.007 0-14.918 12.09-27.012 27.008-27.012s27.012 12.094 27.012 27.012c0 14.914-12.094 27.007-27.012 27.007m0-55c-15.46 0-27.992 12.532-27.992 27.993 0 15.457 12.531 27.992 27.992 27.992s27.992-12.535 27.992-27.992c0-15.461-12.531-27.993-27.992-27.993"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M472.04 326.445c-13.563 0-24.556-10.996-24.556-24.554 0-13.563 10.993-24.555 24.555-24.555 13.563 0 24.555 10.992 24.555 24.555 0 13.558-10.992 24.554-24.555 24.554m0-51.566c-14.918 0-27.008 12.094-27.008 27.012 0 14.918 12.09 27.007 27.008 27.007s27.012-12.09 27.012-27.007c0-14.918-12.094-27.012-27.012-27.012"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -734.501 -453.057)"
    />
    <path
      d="M472.04 277.336c-13.563 0-24.556 10.992-24.556 24.555 0 13.558 10.993 24.554 24.555 24.554 13.563 0 24.555-10.996 24.555-24.554 0-13.563-10.992-24.555-24.555-24.555"
      style={{
        fill: '#d70723',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -734.501 -453.057)"
    />
    <path
      d="M466.566 291.758v19.648h-3.578v-11.238c0-1.863 0-2.414-1.605-2.414h-3.2v-2.242h.38c1.832-.028 4.308-.059 5.093-3.754zM483.59 305.758c0 3.582-3.086 5.91-7.363 5.91-4.485 0-7.25-2.504-7.25-5.91 0-3.086 2.242-4.164 3.23-4.63-2.094-.987-2.531-3.112-2.531-4.276 0-3.055 2.531-5.414 6.754-5.414 4.047 0 6.695 2.183 6.695 5.585 0 1.72-.7 3.204-2.562 4.106 2.269 1.137 3.027 2.824 3.027 4.629m-10.508-.117c0 1.66 1.164 2.796 3.316 2.796 1.895 0 3.293-.992 3.293-2.824 0-.351-.058-2.797-3.293-2.797-3.113 0-3.316 2.215-3.316 2.825m.32-8.352c0 .871.38 2.59 3.028 2.59 2.3 0 2.883-1.484 2.883-2.59 0-2.242-1.778-2.648-2.915-2.648-2.472-.032-2.996 1.57-2.996 2.648"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        stroke: 'none',
      }}
      transform="matrix(1.6541 0 0 1.6541 -734.501 -453.057)"
    />
  </SvgContainer>
);
